import dynamic from 'next/dynamic';

import { PlatformID } from '@common/clients/api';
import { useContextData } from '@common/useContextData';

const FieldMobileVi = dynamic(() =>
    import('@common/svg/images/generated/react/FieldMobileVi').then((mod) => mod.default),
);

const FieldMobileVp = dynamic(() =>
    import('@common/svg/images/generated/react/FieldMobileVp').then((mod) => mod.default),
);

interface Props {
    className: string;
}

export const FieldMobile = (props: Props): React.ReactElement => {
    const { platform } = useContextData();

    return platform.id === PlatformID.VI ? <FieldMobileVi {...props} /> : <FieldMobileVp {...props} />;
};
